import { useProjectUrlParams } from '../../hooks/useProjectUrlParams';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export const useInitProjectQueryParams = () => {
  const projectUrlParams = useProjectUrlParams();
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const getParam = (key: string) => {
      const value = searchParams.get(key);
      return value || undefined;
    };

    const currentStep = Number(getParam('step')) || 1;

    const initProjectState = currentStep === 1 ? projectUrlParams : {};
    const toolsProjectState =
      currentStep === 2
        ? {
            projectId: getParam('projectId') ?? '',
            relatedProjectId: getParam('relatedProjectId'),
          }
        : {
            projectId: '',
          };

    return {
      currentStep: currentStep,
      initProjectState,
      toolsProjectState: toolsProjectState,
    };
  }, [projectUrlParams, searchParams]);
};
